import request from "../api/httpClient.js";
import getEndpoint from "../utils/getEndpoint.js";

export const signup = async (payload) => {
  return await request(getEndpoint("auth", "signup"), { body: payload });
};

export const login = async (payload) => {
  return await request(getEndpoint("auth", "login"), { body: payload });
};

export const logout = async () => {
  return await request(getEndpoint("auth", "logout"));
};

export const resetPassword = async (payload) => {
  return await request(getEndpoint("auth", "resetPassword"), { body: payload });
};

export const refresh = async () => {
  return await request(getEndpoint("auth", "refresh"), {}, false);
};
